/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Case status
 * @export
 * @interface CaseStatus
 */
export interface CaseStatus {
    /**
     * 
     * @type {string}
     * @memberof CaseStatus
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseStatus
     */
    value?: string;
}

/**
 * Check if a given object implements the CaseStatus interface.
 */
export function instanceOfCaseStatus(value: object): value is CaseStatus {
    return true;
}

export function CaseStatusFromJSON(json: any): CaseStatus {
    return CaseStatusFromJSONTyped(json, false);
}

export function CaseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function CaseStatusToJSON(json: any): CaseStatus {
    return CaseStatusToJSONTyped(json, false);
}

export function CaseStatusToJSONTyped(value?: CaseStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

